import { convertToQueryParams } from '../Utils/helper/commonUtils';
import axios from './httpRequest';

class CultServices {
	// auth
	login = async ({ params = {}, data = {}, config = {} } = {}) => {
		return axios.post(`/auth/login`, data, { showLoader: true, ...config });
	};
	// ----

	// calling
	createCall = async ({ params = {}, data = {}, config = {} } = {}) => {
		return axios.post(`/call`, data, { showLoader: true, ...config });
	};
	// ------

	// employees
	getEmployeesList = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		let res = await axios.get(`/users?companyId=${companyId}`, data, { showLoader: true, ...config });
		return res.data;
	};

	// get and post navlist data

	getNavList = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		return axios.get(`/company/navigation/${companyId}`, { showLoader: true, ...config });
	};

	setNavList = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		return axios.post(`/company/navigation/${companyId}`, data, { showLoader: true, ...config });
	};

	//...

	createUser = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/users`, data, { showLoader: true, ...config });
	};

	updateUser = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/users/${id}`, data, { showLoader: true, ...config });
	};

	updatePhoneNumber = async ({ params: { userId }, data = {}, config = {} } = {}) => {
		return axios.put(`/user/phone/${userId}`, data, { showLoader: true, ...config });
	};

	deleteUser = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.delete(`/users/${id}`, data, { showLoader: true, ...config });
	};

	getUserById = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.get(`/users/${id}`, data, { showLoader: true, ...config });
	};

	getAllUsersPaginated = async ({ params: { page, limit,companyId, filterQuery }, data = {}, config = {} } = {}) => {
		return axios.get(
			`/users/pagination?page=${page}&limit=${limit}&companyId=${companyId}&${convertToQueryParams(filterQuery)}`,
			data,
			{
				showLoader: true,
				...config,
			},
		);
	};

	getAllUsersPaginatedv1 = async ({ params: { page, limit, companyId, filterQuery }, data = {}, config = {} } = {}) => {
		return axios.get(
			`/users/pagination?page=${page}&limit=${limit}&companyId=${companyId}&isActive=true&${convertToQueryParams(filterQuery)}`,
			data,
			{
				showLoader: true,
				...config,
			},
		);
	};

	getParticipatedNonParticipatedUsersPaginated = async ({
		params: { page, limit, type, companyId, campaignId, filterQuery },
		data = {},
		config = {},
	} = {}) => {
		return axios.get(
			`/users/pagination?page=${page}&limit=${limit}&companyId=${companyId}&campaignId=${campaignId}&type=${type}&isActive=true&${convertToQueryParams(
				filterQuery,
			)}`,
			data,
			{
				showLoader: true,
				...config,
			},
		);
	};

	getUserNotes = async ({ params: { userId }, config = {} } = {}) => {
		return axios.get(`/users/comments?userId=${userId}`, { showLoader: true, ...config });
	};

	importUserExcel = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/users/import`, data, { showLoader: true, ...config });
	};
	// ----------

	// campaign
	createCampaign = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/compaign`, data, { showLoader: true, ...config });
	};

	updateCampaign = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/compaign/${id}`, data, { showLoader: true, ...config });
	};

	updateCampaignStatus = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/compaign/update-status/${id}`, data, { showLoader: true, ...config });
	};

	getCampaignList = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		let res = await axios.get(`/compaign?companyId=${companyId}`, data, { showLoader: true, ...config });
		return res.data;
	};

	// Get campaing list with pagination same as above api...
	getCampaignListV2 = async ({ params: { companyId , page = 1, limit = 5 , search = '' , status=[] }, data = {}, config = {} } = {}) => {
		let res = await axios.get(`/compaign?companyId=${companyId}&page=${page}&limit=${limit}&search=${search}&status=${status}`, data, { showLoader: true, ...config });
		return res.data;
	};

	// Copy of above api
	getCampaignListV1 = async ({ params: { page = 1, limit = 5, companyId }, data = {}, config = {} } = {}) => {
		let res = await axios.get(`/compaign?companyId=${companyId}&page=${page}&limit=${limit}`, data, {
			showLoader: true,
			...config,
		});
		return res.data;
	};

	getCampaignById = async ({ params: { id }, data = {}, config = {} } = {}) => {
		let res = await axios.get(`/compaign/${id}`, data, { showLoader: true, ...config });
		return res.data;
	};

	getCampaignFilteredUsers = async ({ params: { companyId, compaignId , limit=2, page=1 , callType='total'}, data = {}, config = {} } = {}) => {
		return axios.get(`/compaign/${compaignId}/filtered-compaign-users?limit=${limit}&page=${page}&callType=${callType}`, data, { showLoader: true, ...config });
	};

	deleteCampaign = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.delete(`/compaign/${id}`, data, { showLoader: true, ...config });
	};

	syncCampaign = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.post(`/compaign/${id}/sync-employees`, data, { showLoader: true, ...config });
	};

	getAllModelAssistanst = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/assistant/default?companyId=${companyId}`, { showLoader: true, ...config });
	};

	getModelAssistanst = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/assistant/default?companyId=${companyId}`, { showLoader: true, ...config });
	};

	getFilterValues = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/users/filter-value?companyId=${companyId}`, { showLoader: true, ...config });
	};

	scheduleCampaign = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/compaign/compaign-user/${id}`, data, { showLoader: true, ...config });
	};

	getCampaignUserDetails = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.get(`/compaign/user/${id}`, data, { showLoader: true, ...config });
	};

	extendCampaign = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/compaign/scheduling/${id}`, data, { showLoader: true, ...config });
	};
	// --------

	// dashboard

	getDashboardStats = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/dashboard`, data, { showLoader: true, ...config });
	};

	// ----------

	getContextInsigts = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/reporting-context?company=${companyId}`, { showLoader: true, ...config });
	};

	getCallIssues = async ({ params: { companyId, users = [], campaigns = [] }, config = {} } = {}) => {
		let usersQuery = '';
		if (users.length > 0) {
			usersQuery = `&userIds=${users?.join(',')}`;
		}
		let campaignQuery = '';
		if (campaigns.length > 0) {
			campaignQuery = `&compaignId=${campaigns?.join(',')}`;
		}
		return axios.get(`/call-issues?company=${companyId}${usersQuery}${campaignQuery}`, { showLoader: true, ...config });
	};

	getCriticalRisks = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/critical-risk-alert?company=${companyId}`, { showLoader: true, ...config });
	};

	getIssuesV2 = async ({ params: { companyId , campaignId }, config = {} } = {}) => {
		return axios.get(`/issues-v2?company=${companyId}&campaignId=${campaignId}`, { showLoader: true, ...config });
	};

	getCallRecordings = async ({ params: { page, limit, companyId, users = [], campaigns = [], from, to }, config = {} } = {}) => {
		let usersQuery = '';
		if (users.length > 0) {
			usersQuery = `&userIds=${users?.join(',')}`;
		}
		let campaignQuery = '';
		if (campaigns.length > 0) {
			campaignQuery = `&compaignId=${campaigns?.join(',')}`;
		}
		console.log('to - from : ', to, from);
		if (from && to) {
			return axios.get(
				`/call-recording?company=${companyId}${usersQuery}${campaignQuery}&page=${page}&limit=${limit}&fromDate=${from}&toDate=${to}`,
				{ showLoader: true, ...config },
			);
		} else {
			return axios.get(`/call-recording?company=${companyId}${usersQuery}${campaignQuery}&page=${page}&limit=${limit}`, {
				showLoader: true,
				...config,
			});
		}
	};

	getUserCallRecordings = async ({ params: { page, limit, companyId, users = [], campaigns = [] }, config = {} } = {}) => {
		let usersQuery = '';
		if (users.length > 0) {
			usersQuery = `&userId=${users?.join(',')}`;
		}
		let campaignQuery = '';
		if (campaigns.length > 0) {
			campaignQuery = `&compaignId=${campaigns?.join(',')}`;
		}
		return axios.get(`/user-call-recordings?company=${companyId}${usersQuery}${campaignQuery}&page=${page}&limit=${limit}`, {
			showLoader: true,
			...config,
		});
	};

	getCallRecordingsSuicidalTendency = async ({ params: { page, limit, companyId }, config = {} } = {}) => {
		let usersQuery = '';
		// if (users.length > 0) {
		// 	usersQuery = `&userIds=${users?.join(',')}`;
		// }
		let campaignQuery = '';
		// if (campaigns.length > 0) {
		// 	campaignQuery = `&compaignId=${campaigns?.join(',')}`;
		// }
		return axios.get(`/suicidal-tendency-recordings?${usersQuery}${campaignQuery}&page=${page}&limit=${limit}`, {
			showLoader: true,
			...config,
		});
	};

	getCallRecordingsHarassmentTendency = async ({ params: { page, limit, companyId }, config = {} } = {}) => {
		let usersQuery = '';
		// if (users.length > 0) {
		// 	usersQuery = `&userIds=${users?.join(',')}`;
		// }
		let campaignQuery = '';
		// if (campaigns.length > 0) {
		// 	campaignQuery = `&compaignId=${campaigns?.join(',')}`;
		// }
		return axios.get(`/harassment-tendency-recordings?${usersQuery}${campaignQuery}&page=${page}&limit=${limit}`, {
			showLoader: true,
			...config,
		});
	};

	// Inside userThumbnai 2 new apis->

	getUserCallRecording = async ({ params: { page, limit, userId, company }, config = {} } = {}) => {
		return axios.get(`/user-call-recording?page=${page}&limit=${limit}&userId=${userId}&company=${company}`, {
			showLoader: true,
			...config,
		});
	};

	getCallIssuesByUser = async ({ params: { page, limit, userId, companyId }, config = {} } = {}) => {
		return axios.get(`/call-issues?page=${page}&limit=${limit}&userIds=${userId}&company=${companyId}`, { showLoader: true, ...config });
	};

	getThemeById = async ({ params: { themeId }, config = {} } = {}) => {
		return axios.get(`/themes/${themeId}`, { showLoader: true, ...config });
	};

	// used to get campaigns in dashboard only few information...
	getCampaigns = async ({ params: { companyId , status=[] }, config = {} } = {}) => {
		return axios.get(`/compaign?companyId=${companyId}&status=${status}`, { showLoader: true, ...config });
	};

	getCampaignBasicDetails = async ({ params: { companyId , status=[] }, config = {} } = {}) => {
		return axios.get(`/compaign/getCompaignBasicDetails?companyId=${companyId}&status=${status}`, { showLoader: true, ...config });
	};

	getCampaignInsights = async ({ params: { companyId, campaigns = [] }, config = {} } = {}) => {
		let campaignQuery = '';
		if (campaigns.length > 0) {
			campaignQuery = `&campaignId=${campaigns?.join(',')}`;
		}
		return axios.get(`/campaign-insights?company=${companyId}${campaignQuery}`, { showLoader: true, ...config });
	};

	getCampaignInsightsV2 = async ({ params: { companyId, campaigns = [] }, config = {} } = {}) => {
		let campaignQuery = '';
		if (campaigns.length > 0) {
			campaignQuery = `&campaignId=${campaigns?.join(',')}`;
		}
		return axios.get(`/campaign-insights-v2?company=${companyId}${campaignQuery}`, { showLoader: true, ...config });
	};

	getActionalbleInsigts = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/actionable-insights?company=${companyId}`, { showLoader: true, ...config });
	};

	getPositiveInsights = async ({ params: { companyId , campaignId }, config = {} } = {}) => {
		return axios.get(`/positive-insights-v2?company=${companyId}&campaignId=${campaignId}`, { showLoader: true, ...config });
	};

	addComment = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/compaign/compaign-user/comment`, data, { showLoader: true, ...config });
	};

	getActionalbleInsigtsV2 = async ({ params: { companyId , campaignId }, config = {} } = {}) => {
		return axios.get(`/actionable-insights-v2?company=${companyId}&campaignId=${campaignId}`, { showLoader: true, ...config });
	};

	// company
	updateCompany = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/company/${id}`, data, { showLoader: true, ...config });
	};

	changeUserStatus = async ({ params: { id }, data = {}, config = {} } = {}) => {
		return axios.put(`/users/${id}/status`, data, { showLoader: true, ...config });
	};

	acknowledgeCriticalRecord = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`compaign/compaign-user/acknowledge`, data, { showLoader: true, ...config });
	};

	getCallRecordingsDataForGraph = async ({ params: { from, to , campaignIds }, config = {} } = {}) => {
		return axios.get(`/group-call-recordings?from=${from}&to=${to}&groupBy=0&campaignIds=${campaignIds.join(',')}`, { showLoader: true, ...config });

		// return axios.get(`/group-call-recordings?from=2025-04-08&to=2025-04-14&groupBy=0`, { showLoader: true, ...config });
	};

	// Subscription

	getSubscription = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		return axios.get(`/subscription/credit-availability/${companyId}`, data, { showLoader: true, ...config });
	};

	getSubscriptionUsageAnalytics = async ({ params: { companyId , view }, data = {}, config = {} } = {}) => {
		return axios.get(`/subscription/usage-analytics/${companyId}?view=${view}`, data, { showLoader: true, ...config });
	};

	getCreditDashboardInsights = async ({ params: { companyId }, data = {}, config = {} } = {}) => {
		return axios.get(`/subscription/credits/dashboard-insights?companyId=${companyId}`, data, { showLoader: true, ...config });
	};	

	// Archive/Unarchive Campaign  -> (only for live and stopped campaigns)
	setCampaignArchiveStatus = async ({ params: { campaignId }, data = {}, config = {} } = {}) => {
		return axios.put(`compaign/${campaignId}/toggle-archive`, data, { showLoader: true, ...config });
	}

	// Download report PDF

	getCampaignReportPDF = async ({ params: { campaignId }, config = {} } = {}) => {
		return axios.get(`/pdf/campaign/${campaignId}/insights?.curl=false&force=true`, { ...config });
	};

	// Get Short Campaign Details (Encouraging Vibes, Actionable Insights , issues) :
	getShortCampaignDetails = async ({ params: { companyId , campaignId }, config = {} } = {}) => {
		return axios.get(`/pdf/campaign/${campaignId}/status`, { showLoader: true, ...config });
	};

	// Public Inbound Call APIs

	// 1. Send OTP: Public API no token required
	sendOTP = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/otp/send-otp`, data, { showLoader: true, ...config });
	};

	// 2. Verify OTP: Public API no token required
	verifyOTP = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/otp/verify-otp`, data, { showLoader: true, ...config });
	};

	// 3. Incoming Call Assistants and Details: Public API no token required
	getIncomingCallAssistants = async ({ params: { companyId }, config = {} } = {}) => {
		return axios.get(`/incoming-call/${companyId}/assistants`, { showLoader: true, ...config });
	};

	// 4. Initiate Incoming Call: Public API no token required
	initiateIncomingCall = async ({ data = {}, config = {} } = {}) => {
		return axios.post(`/incoming-call/initiate`, data, { showLoader: true, ...config });
	};

	// 5. Get Incoming Call Data: Private API: token required (userId/companyId)
	getIncomingCallList = async ({ params: { userId, companyId }, data = {}, config = {} } = {}) => {
		return axios.get(
			`/incoming-call/?${userId ? `userId=${userId}` : `companyId=${companyId}`}`,
			data,
			{ showLoader: true, ...config }
		);
	};

	// Above is similler to getIncomingCallList but with pagination
	getIncomingCallListPaginated = async ({ data = {}, config = {} } = {}) => {
    // data should include: page, limit, search, filters
    return axios.post(`/incoming-call/list`, data, { showLoader: true, ...config });
    };

	// statistics INBound Calls
	getIncomingCallStatistics = async ({ params: { from, to, groupBy = 0 },config = {} } = {}) => {
		return axios.get(`/incoming-call/statistics?from=${from}&to=${to}&groupBy=${groupBy}`, { showLoader: true, ...config });
	};
}

const CultService = new CultServices();

export default CultService;
